export default __webpack_public_path__ + "app/assets/lover-cat-65677394.gif";